/* eslint-disable max-len */
import { getWindow } from "utils-lib/getWindow"

// NOTE: Point straight to the bucket when possible for local & dev environments
// so we don't have to deal with cache issues.

import devUrls from "./dev"
import qa2Urls from "./qa2"
import qa3Urls from "./qa3"

const ssrWindow = getWindow()

// CHANGE THIS LINE TO ENABLE QA.
const MOCK_QA_ENVIRONMENT = true // Set true to use QA endpoints.

const envUrls = {
  dev: devUrls,
  qa2: qa2Urls,
  qa3: qa3Urls,
}

// DO NOT CHANGE THIS LINE.
const env = "qa3"
const { origin } = ssrWindow.location
const mockOrigin =
  env === `qa3` ? `https://wmqa3.wm.com` : `https://qa.wm.com`

// set to true to configure the app to load a local chatbot (chatbot has to be running on localhost:4000, this allows you to test chatbot embedded in the context of the app locally)
// command to build and run the chatbot locally, run yarn chatbot build:dev && npx serve apps/chatbot/build  -p 4000
const shouldMockLocalChatbot = false

export default {
  ...envUrls[env],
  aem: {
    AEM_JSON_EN_US: `${mockOrigin}/us/en/datapage.model.json`,
    AEM_JSON_EN_CA: `${mockOrigin}/ca/en/datapage.model.json`,
    AEM_JSON_FR_CA: `${mockOrigin}/ca/fr/datapage.model.json`,
    AEM_JSON_ES_US: `${mockOrigin}/us/es/datapage.model.json`,
    ROOT_AEM_SERVLET_PATH: `${mockOrigin}/content/wm/servlets`,
  },
  okta: {
    ...envUrls[env].okta,
    redirectUri: origin,
  },
  redirectUrls: {
    home: origin,
    register: `${mockOrigin}__LANGROUTE__/user/register`,
    login: `${mockOrigin}__LANGROUTE__/user/login`,
    customerSupport: `${mockOrigin}__LANGROUTE__/support`,
  },
  cloudfront: {
    ...envUrls[env].cloudfront,
  },
  mockOrigin,
  loginRedirect: `http://localhost:3000__LANGROUTE__`,
  shouldMockQA: MOCK_QA_ENVIRONMENT,
  ...(shouldMockLocalChatbot
    ? {
        chatbot: {
          ...envUrls[env].chatbot,
          host: {
            domain: "http://localhost:3000",
            subdirectory: "/chatbot/config.json",
          },
        },
      }
    : {}),
}
